var ColorUtil = /** @class */ (function () {
    function ColorUtil() {
    }
    ColorUtil.checkDarkOrLight = function (color) {
        var r, g, b;
        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {
            // If HEX --> store the red, green, blue values in separate variables
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
            r = color[1];
            g = color[2];
            b = color[3];
        }
        else {
            // If RGB --> Convert it to HEX: http://gist.github.com/983661
            color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
            r = color >> 16;
            g = (color >> 8) & 255;
            b = color & 255;
        }
        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
        // Using the HSP value, determine whether the color is light or dark
        if (hsp > 200) {
            return 'light';
        }
        else {
            return 'dark';
        }
    };
    ColorUtil.increaseBrightness = function (hex, percent) {
        if (!hex || !percent)
            return;
        hex = hex.replace(/^\s*#|\s*$/g, '');
        if (hex.length === 3) {
            hex = hex.replace(/(.)/g, '$1$1');
        }
        var r = parseInt(hex.substr(0, 2), 16), g = parseInt(hex.substr(2, 2), 16), b = parseInt(hex.substr(4, 2), 16);
        return ('#' +
            (0 | ((1 << 8) + r + ((256 - r) * percent) / 100))
                .toString(16)
                .substr(1) +
            (0 | ((1 << 8) + g + ((256 - g) * percent) / 100))
                .toString(16)
                .substr(1) +
            (0 | ((1 << 8) + b + ((256 - b) * percent) / 100)).toString(16).substr(1));
    };
    ColorUtil.decreaseBrightness = function (hex, percent) {
        if (!hex || !percent)
            return;
        var r = parseInt(hex.substr(1, 2), 16), g = parseInt(hex.substr(3, 2), 16), b = parseInt(hex.substr(5, 2), 16);
        return ('#' +
            (0 | ((1 << 8) + (r * (100 - percent)) / 100)).toString(16).substr(1) +
            (0 | ((1 << 8) + (g * (100 - percent)) / 100)).toString(16).substr(1) +
            (0 | ((1 << 8) + (b * (100 - percent)) / 100)).toString(16).substr(1));
    };
    return ColorUtil;
}());

export { ColorUtil as default };
//# sourceMappingURL=color.util.js.map
